/* ════════════ HOARD EMBERS ════════════
   The C++ dossier's atmosphere: embers rising off the dragon's hoard,
   with scope-resolution operators and the odd template bracket
   drifting up among the sparks. */

import { fillBars } from "./statbars";
import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function embers(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#embers")!;
  const ctx = c.getContext("2d")!;
  const TOKENS = ["::", "++", "<T>", "&&", "~", "constexpr"];
  const emberCols = ["#ff7a3c", "#ffb37a", "#6f8fff", "#9bb0ff"];

  type Mote = {
    x: number;
    y: number;
    vy: number;
    sway: number;
    phase: number;
    text: string | null; // null = plain ember pixel
    col: string;
    size: number;
    alpha: number;
  };
  let motes: Mote[] = [];

  const make = (anywhere = false): Mote => {
    const isToken = Math.random() < 0.22;
    return {
      x: Math.random() * c.width,
      y: anywhere ? Math.random() * c.height : c.height + 12,
      vy: 0.18 + Math.random() * 0.45,
      sway: 0.2 + Math.random() * 0.8,
      phase: Math.random() * Math.PI * 2,
      text: isToken ? TOKENS[(Math.random() * TOKENS.length) | 0]! : null,
      col: isToken ? "#6f8fff" : emberCols[(Math.random() * emberCols.length) | 0]!,
      size: isToken ? 12 : Math.random() > 0.85 ? 3 : 2,
      alpha: 0.2 + Math.random() * 0.4,
    };
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(55, Math.floor((c.width * c.height) / 30000));
    motes = Array.from({ length: count }, () => make(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const m of motes) {
      ctx.globalAlpha = m.alpha;
      ctx.fillStyle = m.col;
      if (m.text) {
        ctx.font = `${m.size}px "IBM Plex Mono", monospace`;
        ctx.fillText(m.text, m.x | 0, m.y | 0);
      } else {
        ctx.fillRect(m.x | 0, m.y | 0, m.size, m.size);
      }
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  let t = 0;
  const tick = () => {
    if (signal.aborted) return;
    t += 0.016;
    for (const m of motes) {
      m.y -= m.vy;
      m.x += Math.sin(t + m.phase) * m.sway * 0.2;
      if (m.y < -14) Object.assign(m, make());
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage((signal) => {
  embers(signal);
  fillBars();
});
